import React from 'react';

export default function CustomPinnedRowRenderer(props){
  let sum = props.value;

  if (!Number(props.value)){
    const currentField = props.colDef.field;
    sum = props.data[currentField];
  }

  return <span style={props.style}>{sum}</span>;
}